module.exports = __webpack_public_path__ + "img/icon-zoom-in.ac823aac.svg";